//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React from 'react';
// import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core';
// import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
// import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
// import IconButton from '@material-ui/core/IconButton';
// import ButtonGroup from '@material-ui/core/ButtonGroup';
// import Button from '@material-ui/core/Button';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdTypography from '../../common/elemental/AfitdTypography';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        root: {
            display: 'flex',
            justifyContent: 'flex-start',
            margin: '0 0 16px 5px',
        },
        //chatRightBlock2In h6
        messagesNewText: {
            letterSpacing: 0,
            color: '#fd811f',
        },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes, props } = params;
    const { unreadMessagesCount } = props;

    const defns = {
        messagesNewText: {
            variant: 'caption',
            clsLightBold: true,
            value: `${unreadMessagesCount} NEW MESSAGE${unreadMessagesCount > 1 ? 'S' : ''}`,
        },
    };

    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const MessagesDate = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();
    // const context = useContext(LayoutContext);
    // const xxxxxx = _get(context, 'xxxxxx');

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    // const [yyyyyyyyy, setYyyyyyyyy] = useState();

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    const { newMessageSignRef } = props;

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    // useEffect(() => {
    //     const newDefns = getDefns(props, { });
    //     setDefns(newDefns);
    // }, [props]);

    //---------------------------------------------------------------------
    // Defns
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div {...defns.root} ref={newMessageSignRef}>
            <AfitdTypography {...defns.messagesNewText} />
        </div>
    );
};

export default MessagesDate;
